import axios from 'axios'

export function liveroomSetAccount(data) {
    return {
        type: 'ACCOUNT_SET_LIVEROOM',
        payload: data
    }
}

export function checkHasLiveroom() {
    return dispatch => {
        axios.get('/api/account/has_liveroom').then(res => {
            if (res.data.code === 0) {
                return dispatch(liveroomSetAccount(res.data.data.has_liveroom))
            }
        }).catch(error => {
            console.log(error)
        })
    }
}



// WEBPACK FOOTER //
// ./src/actions/liveroom.js